export const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:9001';
// export const BASE_URL = 'https://api.bibikalka.com.ua/';

export const STORE_URL = process.env.REACT_APP_STORE_URL || 'https://bibikalka.com.ua';

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || '';

// export const BASE_URL = 'B';
export const API_URLS = {
  AUTH: {
    SIGN_IN: '/auth/admin/sign-in',
    ME: '/auth/admin/me',
  },
  PROVIDER: {
    PRODUCTS: '/admin/provider/products',
    ALL: '/admin/provider',
  },
  STORAGE: {
    UPLOAD: '/storage/upload',
  },
  PURCHASE: {
    PRODUCTS: '/admin/purchase/products',
    CREATE: '/admin/purchase',
    ALL: '/admin/purchase',
  },
  PRODUCT: {
    CREATE: '/admin/product',
    ALL: '/admin/product/list',
    GET: '/admin/product/[id]',
    EDIT: '/admin/product/[id]',
    ADD_REVIEW: '/product/[link]/reviews',
  },
  ORDER: {
    ALL: '/admin/order/list',
    BY_ID: '/admin/order/',
  },
  CATEGORY: {
    CREATE: '/admin/product/category',
    ALL: '/admin/product/category',
    CHANGE_VISIBLE: 'admin/product/category/[name]/visible',
    GET: '/admin/product/category/[name]',
    EDIT: '/admin/product/category/[name]',
  },
  MANUAL_DELIVERY: {
    PROCESS: '/admin/order/process',
  },
  USER: {
    MARK_IS_FRAUD: '/admin/user/fraud',
    LIST: '/admin/user',
  },
  METRIC: {
    GET_METRIC: '/admin/metric',
  },
  REDIRECT: {
    LIST: '/admin/redirect',
    GET: '/admin/redirect/[id]',
    CREATE: '/admin/redirect',
    EDIT: '/admin/redirect/[id]',
  },
  TOYSI: {
    CATEGORIES: '/admin/toysi/categories',
    PRODUCTS: '/admin/toysi/products',
    BULK_CREATE: '/admin/toysi/bulk-create',
    IMPORTED_SKUS: '/admin/toysi/imported-skus',
  },
  FEED: {
    GENERATE: '/admin/feed/generate',
    PRICE_COMPETITIVENESS: '/admin/feed/price-competitiveness',
  },
  EXPENSE: {
    CREATE: '/admin/expense',
    LIST: '/admin/expense',
  },
  USER_EVENT: {
    LIST: '/admin/user-event',
    CLEAR: '/admin/user-event',
  },
  SOCIAL: {
    GENERATE: '/admin/social/generate',
    PUBLISH: '/admin/social/[id]/publish',
    GET: '/admin/social/[id]',
    LIST: '/admin/social',
    TIKTOK_AUTH_URL: '/admin/social/tiktok/auth-url',
    TIKTOK_STATUS: '/admin/social/tiktok/status',
  },
  AI: {
    BALANCE: '/admin/ai/balance',
  },
  CREDENTIALS: {
    CREATE: '/admin/credentials',
    LIST: '/admin/credentials',
  },
  GOOGLE_ADS: {
    LIST: '/admin/google-ads/campaigns',
    CREATE: '/admin/google-ads/campaigns',
  },
};

export const APP_URLS = {
  ORDER_VIEW: '/order/details/[id]',
  USER_VIEW: '/user/details/[id]',
};

export const DEFAULT_VALUES = [
  { value: '500' }, { value: '1000' }, { value: '2500' }, { value: '5000' }, { value: '10000' },
];

export const ORDER_STATUS = {
  FALLBACK: { status: 'Fallback', color: '#22242b' },
  DELIVERED: { status: 'Delivered', color: '#b7eb8f' },
  PAID: { status: 'Paid', color: '#69c0ff' },
  PENDING: { status: 'Pending', color: '#fadb14' },
  CREATED: { status: 'Created', color: '#5c60e5' },
  FAIL: { status: 'Fail', color: '#ff4d4f' },
  REFUND: { status: 'Refund', color: '#4ac9db' },
  CANCELED: { status: 'Canceled', color: '#D3D3D3' },
};

// eslint-disable-next-line no-shadow
export enum CardType {
  Pin = 'cardType:pin',
  CardNumber = 'cardType:number',
  Serial = 'cardType:serial'
}

export const CardTypeMap = {
  [CardType.Pin]: 'Pin code',
  [CardType.CardNumber]: 'Card number',
  [CardType.Serial]: 'Serial',
};
